

export class TabHelper {
	static TabViewProps = {
		panelContainer: { className: 'peoplePanelContainer' },
		nav: { className: 'peopleTabViewNavUl' },
		inkbar: { className: 'peopleTabInkBar' },
	};
	static TabPanelProps = {
		headerAction: { className: 'peopleTabViewNavLink' },
		header: { className: 'peopleTabViewNavLi' },
	}
}

